export default __webpack_public_path__ + "assets/logo_klix-f3a887f2647c332bff2723a876b43147.png";